@if (!document() || document().isLoading) {
  <div class="w-[100vw] h-[100vh] flex flex-col items-center justify-center">
    <ui-loading-spinner size="50" />
  </div>
} @else if (document().error) {
  <app-error-page [error]="document().error" />
} @else {
  @if (document().document; as doc) {
    <app-document-preview-header [document]="doc" [organizationId]="organizationId()">
      <a [routerLink]="['/organizations', organizationId(), 'analysis']" class="flex-none">
        <ui-button [iconOnly]="true" mode="outlined">
          <ng-icon name="heroArrowLeft" size="20" class="!block" />
        </ui-button>
      </a>
    </app-document-preview-header>
    <app-document-preview
      [document]="doc"
      [organizationID]="organizationId()"
      class="block w-[100vw] h-[calc(100vh-56px)]"
    />
  }
}
